import React from "react";
import { FormattedMessage } from "react-intl";
import driversEntityOptions from "../../drivers/config/entity";
import locationsEntityOptions from "../../locations/config/entity";
import ordersEntityOptions from "../../orders/configs/entity";
import usersEntityOptions from "../../users/config/entity";
import organizationAssigneesOptions from "../../organizationAssignees/config/entity";
import projectsClientEntityOptions from "../../clientProjects/config/entity";
import { organizationTypes } from "./formFields";

export default [
    {
        name: "id",
        label: "Client ID",
    },
    {
        id: "title",
        name: "name",
        label: "Client Name",
        type: "string",
        isEditable: true,
    },
    {
        id: "subtitle",
        name: "organizationType",
        label: "Organization Type",
        type: "select",
        format: true,
        data: organizationTypes,
        isEditable: true,
    },
    {
        name: "commercialRegisterName",
        label: <FormattedMessage id="client.commercialRegisterName" />,
        type: "string",
        isEditable: true,
    },
    {
        name: "website",
        label: <FormattedMessage id="client.website" />,
        type: "string",
        isEditable: true,
    },
    {
        name: "industry",
        label: <FormattedMessage id="client.industry" />,
        type: "string",
        isEditable: true,
    },
    {
        name: "headquarter",
        label: <FormattedMessage id="client.headquarter" />,
        type: "string",
        isEditable: true,
    },
    {
        name: "startDate",
        label: <FormattedMessage id="client.startDate" />,
        type: "dateAndTime",
        isEditable: true,
    },
    {
        name: "inactiveDate",
        label: <FormattedMessage id="client.inactiveDate" />,
        type: "dateAndTime",
        isEditable: true,
    },
    {
        name: "attachments",
        label: "Attachments",
        type: "attachment",
        isEditable: true,
        validation: {
            required: false,
        },
        entityName: "attachments",
        includeEntityName: "attachments",
    },
    {
        name: "orders",
        label: "Orders",
        type: "relation",
        entityName: "orders",
        entityOptions: ordersEntityOptions,
    },
    {
        name: "driverIds",
        label: "Drivers",
        type: "relation",
        entityName: "drivers",
        entityOptions: driversEntityOptions,
    },
    {
        name: "users",
        label: "Users",
        type: "relation",
        entityName: "users",
        entityOptions: usersEntityOptions,
    },
    {
        name: "locations",
        label: "Locations",
        type: "relation",
        entityName: "locations",
        entityOptions: locationsEntityOptions,
    },
    {
        name: "organizationAssignees",
        label: "Admins",
        type: "relation",
        entityName: "organization-assignees",
        entityOptions: organizationAssigneesOptions,
    },
    {
        name: "projects",
        label: "Projects",
        type: "relation",
        entityName: "projects",
        entityOptions: projectsClientEntityOptions,
    },
    {
        id: "metabase",
        name: "metabaseLink",
        label: <FormattedMessage id="client.metabase" />,
        type: "string",
        isEditable: true,
        validation: {
            required: false,
        },
    },
];
